/**
 * Processes prints data from the current order, matching them to available sizes and filtering out invalid or duplicate entries.
 *
 * @param {Array} prints - The array of print objects from the basket endpoint.
 * @param {Array} allSizes - The complete list of available size objects from the config.
 * @param {Array} allFinishes - The complete list of available finish objects from the config.
 * @returns {Array} An array of photo objects ready to be added to the order state.
 */
export function processOrderPrints(prints, allSizes, allFinishes) {
  if (!prints || prints.length === 0) {
    return [];
  }

  const validFinishNames = allFinishes.map((f) => f.name);
  const loadedPhotos = [];
  const addedPhotos = new Set(); // Track added photos and prevent duplicates

  prints.forEach((print) => {
    // 1. Validate the finish
    if (!validFinishNames.includes(print.finish)) {
      return; // Skip this print
    }

    // 2. Find the corresponding size
    const size = allSizes.find((s) => {
      const regex = new RegExp(
        `${print.size}.+${print.finish}.+${print.border}$`,
      );
      return s.key.match(regex);
    });

    if (!size) {
      return; // Skip if no matching size is found
    }

    // 3. Check for duplicates before adding
    const photoIdentifier = `${print.image_id}__${size.key}`;
    if (addedPhotos.has(photoIdentifier)) {
      return; // Skip duplicate photo for the same size.
    }

    // 4. Add the processed photo to lists
    loadedPhotos.push({
      ...print,
      fromBasket: true,
      sizeKey: size.key,
    });
    addedPhotos.add(photoIdentifier);
  });

  return loadedPhotos;
}
